// extracted by mini-css-extract-plugin
export var actions = "_3z-0";
export var actionsContainer = "_3z-6";
export var border = "_3z-1";
export var childFullHeight = "_3z-d";
export var collapse = "_3z-2";
export var content = "_3z-8";
export var contentChild = "_3z-c";
export var fullscreen = "_3z-a";
export var headerContainer = "_3z-3";
export var headerRow = "_3z-5";
export var hidePadding = "_3z-9";
export var noScrollX = "_3z-e";
export var noScrollY = "_3z-f";
export var optOutTopPadding = "_3z-b";
export var pagePadding = "_3z-7";
export var profile = "_3z-g";
export var profileContainer = "_3z-h";
export var profileImage = "_3z-i";
export var profileMain = "_3z-j";
export var profileSubtitle = "_3z-l";
export var profileTitle = "_3z-k";
export var tabsWrapper = "_3z-4";
export var title = "_3z-m";